import { Router } from '@angular/router';
import { Component, OnInit, EventEmitter, Input, Output, Renderer } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { Usuario } from '../../../models/usuario';
import { UsuarioService } from '../../../services/usuario.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'app-usuario-modal',
	templateUrl: './usuario-modal.component.html',
	styleUrls: ['./usuario-modal.component.css'],
	providers: [UsuarioService]
})
export class UsuarioModalComponent implements OnInit {
	@Output() sendUsuario = new EventEmitter();
	@Input() qs: String = "";
	public title: String;
	public usuarios: Array<Usuario> = [];
	public selectedRow: Number;
	public usuario: Usuario;
	public pagination: Pagination;
	public loading = false;

	constructor(
		public usuarioService: UsuarioService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
		public bsModalRef: BsModalRef,
	) {
		this.title = "Usuarios";
		this.pagination = new Pagination();
	}

	ngOnInit() {
		this.getUsuarios();
	}

	getUsuariosBySearch(text){
		let qs = "&q[usuario]=" + text;
		this.pagination.current_page = 1;
		this.getUsuarios(qs);
	}

	getUsuarios(qs = ""){
		this.loading = true;
		this.usuarioService.getAll("?page="+this.pagination.current_page+"&per_page=10&embed=persona,perfil" + this.qs + qs).subscribe(
			res => {
				this.loading = false;
				this.usuarios = res.data;

				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},	
			err => {
				this.loading = false;
				this.usuarios = [];
			}
		);
	}

	onSelectRow(usuario, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.usuario = usuario;
	}

	onDBLClick(usuario,i){
		this.onSelectRow(usuario,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto usuario
		this.sendUsuario.emit(this.usuario);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	next(){
		this.pagination.current_page++;
		this.getUsuarios();
	}

	prev(){
		this.pagination.current_page--;
		this.getUsuarios();
	}

	first(){
		this.pagination.current_page = 1;
		this.getUsuarios();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getUsuarios();
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/usuario-modal/usuario-modal.component.ts